const viewSwitchers = document.querySelectorAll('.view-switcher');

viewSwitchers.forEach((viewSwitcher) => {
  const parent = viewSwitcher.closest('.sc-news-card-list');
  const listBtn = viewSwitcher.querySelector('.list-view');
  const gridBtn = viewSwitcher.querySelector('.grid-view');

  listBtn.addEventListener('click', () => {
    listBtn.classList.add('is-active');
    gridBtn.classList.remove('is-active');
    parent.classList.add('list-view');
  });

  gridBtn.addEventListener('click', () => {
    gridBtn.classList.add('is-active');
    listBtn.classList.remove('is-active');
    parent.classList.remove('list-view');
  });
});
